import { useParams } from 'react-router-dom';
import navConfig from './config-navigation';
import { filterNavConfig } from './filterNavConfig';
import { ROLES_LABELS, useRole } from '../../../pages/common/guards/RoleGuard.jsx';
import { useMarketplaceContext } from '../../../context-state/MarketplaceContext.jsx';
import { useAuthContext } from '../../../context-state/AuthContext.jsx';

// Single source of truth for the visible nav items. Every nav consumer
// (vertical/mini/horizontal navs, searchbar) must use this instead of the raw
// navConfig: the raw module is a shared singleton and per-consumer ad-hoc
// filtering used to mutate it destructively.
export default function useFilteredNavConfig() {
    const routeParams = useParams();
    const { marketplace } = useMarketplaceContext();
    const { user, getPrimaryAccount } = useAuthContext();
    const { userAllowToAccess, getUserRole } = useRole();
    const userRole = getUserRole();
    const isLimitedRole = userRole === ROLES_LABELS.CASHIER || userRole === ROLES_LABELS.SCANNER;

    return filterNavConfig(navConfig, {
        user,
        marketplace,
        primaryAccount: getPrimaryAccount(),
        userAllowToAccess,
        isLimitedRole,
        routeParams,
    });
}
